import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { colors, fonts, breakpoints, GlobalStyle } from './styles/theme';
import { LanguageProvider } from './LanguageContext';
import { AuthProvider } from './AuthContext';

// Import components
import Header from './components/Header';
import Login from './components/admin/Login';
import Dashboard from './components/admin/Dashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import Solutions from './components/Solutions';
import Cases from './components/Cases';
import Blog from './components/Blog';
import ESG from './components/ESG';
import Contact from './components/Contact';
import Footer from './components/Footer';
import MaqRsu from './components/MaqRsu';
import UsinaCidadeLimpa from './components/UsinaCidadeLimpa';

// Define theme object for ThemeProvider
const theme = {
  colors,
  fonts,
  breakpoints,
};

// Home page component
const Home = () => (
  <>
    <HeroSection />
    <HowItWorks />
    <Solutions />
    <Cases />
    <Blog />
    <ESG />
    <Contact />
  </>
);

// ScrollToTop component to handle scroll position on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <>
              <GlobalStyle />
              <ScrollToTop />
              <Routes>
                {/* Admin routes */}
                <Route path="/admin/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                
                {/* Public routes */}
                <Route
                  path="/"
                  element={
                    <>
                      <Header />
                      <Home />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path="/maq-rsu"
                  element={
                    <>
                      <Header />
                      <MaqRsu />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path="/usina-cidade-limpa"
                  element={
                    <>
                      <Header />
                      <UsinaCidadeLimpa />
                      <Footer />
                    </>
                  }
                />
              </Routes>
            </>
          </ThemeProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
